import React from "react";
import {
  Outlet,
  useSearchParams,
  useNavigate
} from "react-router-dom";
import AuthContext from '../../providers/AuthProvider'
import AuthService from '../../services/AuthService'
import UserService from '../../services/UserService'
import ClientContext from '../../providers/CurrentClientProvider'
import { syncAmplitudeIdentity } from '../../services/amplitudeIdentity'
import { initGuidesAndSurveysForCurrentUser } from '../../services/amplitudeBootstrap'


function AuthMiddleware() {
  let auth = AuthContext.useAuth();
  const { logout, setUser } = auth
  const clientContext = ClientContext.useClient()
  let navigate = useNavigate()
  let [searcharams, setSearchParams] = useSearchParams();
  const tmpAccessToken = searcharams.get('token') || searcharams.get('access_token');
  const [isAuthorized, setIsAuthorized] = React.useState(false)

  React.useEffect(() => {
    let isActive = true
    const _accessToken = AuthService.getAccessToken();
    const accessToken = tmpAccessToken || _accessToken

    if (!accessToken) {
      navigate('/login', { replace: true })
      return () => {
        isActive = false
      }
    }

    const handleAuthenticationFailure = () => {
      if (!isActive) {
        return
      }

      logout()
      navigate('/login', { replace: true })
    }

    const refreshCurrentUser = async () => {
      if( tmpAccessToken ) {
      // If get token from URL params, then save it into localstorage
        AuthService.setAccessToken(tmpAccessToken)
      }

      try {
        const success = await UserService.getCurrentUser()

        if (!success) {
          handleAuthenticationFailure()
          return
        }

        if (!isActive) {
          return
        }

        const resolvedUser = { ...success }

        if (!resolvedUser.client) {
          try {
            const singleClient = await UserService.getSingleClient()
            if (singleClient) {
              resolvedUser.client = singleClient
            }
          } catch (singleClientError) {
            console.warn('Unable to hydrate single-client assignment during auth refresh:', singleClientError)
          }
        }

        if (!isActive) {
          return
        }

        AuthService.setCurrentUser(resolvedUser, true)
        setUser(resolvedUser)
        syncAmplitudeIdentity({ user: resolvedUser, client: resolvedUser.client })
        void initGuidesAndSurveysForCurrentUser()

        if (resolvedUser.client) {
          clientContext?.setClient?.(resolvedUser.client)
        }

        setIsAuthorized(true)

        if (tmpAccessToken) {
          setSearchParams({}, { replace: true })
        }
      } catch (error) {
        handleAuthenticationFailure()
      }
    }

    refreshCurrentUser()

    return () => {
      isActive = false
    }
  }, [tmpAccessToken, navigate, logout, setSearchParams, setUser]);

  if (!isAuthorized) {
    return null
  }

  return <Outlet />
}

export default AuthMiddleware